import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const CriminalRecordModal = (props) => <RequestDetailModal {...props} />;

export default CriminalRecordModal;
